import { render, staticRenderFns } from "./TameFilter.vue?vue&type=template&id=5516957c"
import script from "./TameFilter.vue?vue&type=script&lang=js"
export * from "./TameFilter.vue?vue&type=script&lang=js"
import style0 from "./TameFilter.vue?vue&type=style&index=0&id=5516957c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports